      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>

      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12">
            <p-panel header="{{ 'EXCEPCIONESGMF.LBL_VISUALIZAREXCEPCIONES' | translate}}" *ngIf="excepcionGMF">
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <h2 class="titulo-pagina">{{'EXCEPCIONESGMF.LBL_INFORMACIONGENERAL' | translate}}</h2>
                </div>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_CODIGO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{excepcionGMF ? excepcionGMF.codigo : ''}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_NOMBRE' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMF ? excepcionGMF.nombre : ''}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_DESCRIPCION' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMF ? excepcionGMF.descripcion : ''}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMF.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
                  translate)}}</strong></label>
              </div>


                <div class="grid">
                  <div class="col-12 md:col-12 lg:col-12">
                    <h2 class="titulo-pagina">{{'EXCEPCIONESGMF.LBL_CONFIGURACIONEXCEPCIONESGMF' | translate}}</h2>
                  </div>
                </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_ESPECIE' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{excepcionGMFFormaDesembolso ?
                  excepcionGMFFormaDesembolso.nombreFormasDesembolsos : ''}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_CRUZADO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMFFormaDesembolso ?
                  excepcionGMFFormaDesembolso.nombreCruzado : ''}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_PRIMERBENEFICIARIO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{excepcionGMFFormaDesembolso ?
                  excepcionGMFFormaDesembolso.nombrePrimerBeneficiario : ''}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_BENEFICIARIO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMFFormaDesembolso ?
                  excepcionGMFFormaDesembolso.nombreBeneficiario : ''}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_TIPOCREDITO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{excepcionGMFTipoCredito ?
                  excepcionGMFTipoCredito.tipoCredito : ''}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'EXCEPCIONESGMF.LBL_MANEJACUENTAAHORROSTITULAR' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{excepcionGMF.indicadorManejaCtaAhorros ? ('LBL_SI' | translate) : ('LBL_NO' |
                  translate)}}</strong></label>
              </div>



              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <h2 class="titulo-pagina">{{'EXCEPCIONESGMF.LBL_CONFIGURACIONDESTINOSEXENTOS' | translate}}</h2>
                </div>
              </div>
              <div class="grid">
                <div class="col-12">
                  <p-table [columns]="columnas"
                           [value]="excepcionesGMFDestinos" selectionMode="single" dataKey="idExcepcionesGMFDestinos"
                           [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr [pSelectableRow]="row">
                        <td>{{row.destino}}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="columns.length">
                          {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-panel>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                    pButton (click)="regresar()"></button>
          </div>
        </div>
      </div>

